import { Component, ViewChild } from '@angular/core';
import { PermisosAuthService } from '../../service/permiso-auth.service';
import { PermisosUsuariosService } from '../../service/usuarios.service';
import * as jwtDecode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css'],
})
export class ChangePassComponent {
  constructor(
    private readonly auth: PermisosAuthService,
    private readonly usuariosService: PermisosUsuariosService,
    private readonly cookie: CookieService,
    private readonly router: Router
  ) {}

  logout() {
    this.auth.logout();
  }

  error = false;
  message = '';

  isValid = true;

  @ViewChild('dialog') private readonly dialog!: DialogComponent;

  changePass(p1: string, p2: string) {
    this.error = false;
    this.message = '';
    if (p1 && p2) {
      if (p1 === p2) {
        if (this.isValid) {
          this.dialog.confirm(
            '¿Está seguro de ingresar la siguiente contraseña?',
            'Confirmación de carga',
            () => {
              this.onChangePass(p1);
            }
          );
        } else {
          this.error = true;
          this.message = 'No cumple con los requisitos';
        }
      } else {
        this.error = true;
        this.message = 'Las contraseñas no coinciden';
      }
    } else {
      this.error = true;
      this.message = 'Debe completar los campos';
    }
  }
  onChangePass(p1: string) {
    this.dialog.start();
    const token = this.cookie.getAll()['x-token'];
    //* Decodificamos el token para saber la sección
    const decodedToken = jwtDecode.jwtDecode(token!);
    const id = (decodedToken as any).sub;
    this.usuariosService
      .update(id, {
        password: p1,
        first_login: false,
        fecha_firstlogin: new Date(),
      })
      .subscribe({
        next: (data) => {
          this.auth.saveTokenToCookie(data as string);
          this.dialog.stop(
            'La contraseña se modificó correctamente.',
            'Confirmación de carga',
            () => {
              this.router.navigate(['permisos']);
            }
          );
        },
        error: (e) => {
          if (e.error ? e.error.statusCode === 409 : false) {
            this.dialog.stop(
              'La contraseña es la misma que la anterior.',
              'Conflicto',
              () => {},
              true
            );
          } else if (e.error ? e.error.statusCode === 404 : false) {
            this.dialog.stop(
              'No se encontró el usuario.',
              'No encontrado',
              () => {},
              true
            );
          } else {
            this.dialog.stop(
              'Error interno del sistema.',
              'Error',
              () => {},
              true
            );
          }
        },
      });
  }
}
